import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import Countdown from 'components/Countdown';
import Switch from '@material-ui/core/Switch';
import { THEME_TABLE } from 'constants/types';
import DefaultImage from 'assets/images/think/table.jpg';
import { ThinkSeedSmallCardWrapper } from './styles';

function ThinkSeedSmallCard(props) {
  const {
    literals, data, classesList, history,
    enableItemFromSerendipity, disableItemFromSerendipity, itemsPreferencesFromSerendipity,
  } = props;

  const [enabled, setEnabled] = useState(!_.find(itemsPreferencesFromSerendipity, item => item.element_type === THEME_TABLE && item.element_id === data.id && !item.enabled));

  const handleChangeEnabled = () => {
    if (!enabled) {
      enableItemFromSerendipity(THEME_TABLE, data.id);
    } else {
      disableItemFromSerendipity(THEME_TABLE, data.id);
    }

    setEnabled(!enabled);
  };

  const [timeClick, setTimeClick] = useState(null);

  const handleClick = (event) => {
    const diff = moment().valueOf() - timeClick;
    if (diff < 200 && !window.$(event.target).hasClass('MuiSwitch-input')) {
      history.push(`/theme-table/${data.id}`);
    }
  };

  const handleMouseDown = () => {
    setTimeClick(moment().valueOf());
  };


  const style = {
    backgroundImage: `url(${data.image || DefaultImage})`,
  };

  let classesStr = classesList.join(' ');
  if (!enabled) {
    classesStr += ' disabled';
  }
  return (
    <ThinkSeedSmallCardWrapper enabled={enabled} className={classesStr} onClick={handleClick} onMouseDown={handleMouseDown}>
      <div className='header' style={style}>
        <div className='opacity' />
        <div className='title'>{literals.title}</div>
        {data && typeof data.limit_date !== 'undefined' ? (
          <Countdown time={data.limit_date} />
        ) : null}
      </div>
      <div className='body'>
        <div>{data.name}</div>
      </div>
      <div className='footer'>
        <div>
          <Switch
            checked={enabled}
            size='small'
            onChange={handleChangeEnabled}
            name='check_enabled'
            color='primary'
          />
        </div>
      </div>
    </ThinkSeedSmallCardWrapper>
  );
}

ThinkSeedSmallCard.propTypes = {
  literals: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  enableItemFromSerendipity: PropTypes.func.isRequired,
  disableItemFromSerendipity: PropTypes.func.isRequired,
  itemsPreferencesFromSerendipity: PropTypes.array,
  classesList: PropTypes.array,
};

ThinkSeedSmallCard.defaultProps = {
  classesList: [],
  itemsPreferencesFromSerendipity: [],
};

export default ThinkSeedSmallCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ThinkSeedSmallCard/components/index.jsx